import { render, staticRenderFns } from "./AiForm.vue?vue&type=template&id=16cccb80&scoped=true"
import script from "./AiForm.vue?vue&type=script&lang=js"
export * from "./AiForm.vue?vue&type=script&lang=js"
import style0 from "./AiForm.vue?vue&type=style&index=0&id=16cccb80&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16cccb80",
  null
  
)

export default component.exports